import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router'

import { useCartModal } from '@features/cart'
import { useCartStore } from '@features/cart/model/useCartStore'
import ControlCart from '@features/cart/ui/control'
import { useAddressStore } from '@features/shipping-methods'

import { Product, useProductQuery } from '@shared/generated'
import Button from '@shared/ui/button'
import { formatPrice } from '@shared/uttils'
import getNoun from '@shared/uttils/getNoun'

import styles from './styles.module.scss'

// type TabButtonProps = {
//   title: string;
//   icon: string;
//   counter?: number | string | null;
//   href?: string;
//   isAddingCart?: boolean;
//   price?: string | number;
//   countText?: string;
// } & React.AnchorHTMLAttributes<HTMLAnchorElement> &
//   React.ButtonHTMLAttributes<HTMLButtonElement>;

// const TabButton = ({
//   title,
//   icon,
//   counter,
//   href,
//   isAddingCart,
//   price,
//   countText,
//   ...props
// }: TabButtonProps) => {
//   const content = (
//     <>
//       <span className={styles.tabbar__button_icon}>
//         <ReactSVG src={`/icons/${icon}.svg`} />
//       </span>
//       {!isAddingCart && (
//         <span className={styles.tabbar__button_title}>{title}</span>
//       )}
//       {isAddingCart && (
//         <span className={styles.tabbar__cart_block}>
//           <span className={styles.tabbar__price}>{price}</span>
//           <span className={styles.tabbar__productsCount}>{countText}</span>
//         </span>
//       )}
//       {counter != null && counter !== 0 && counter !== '0' && (
//         <span className={styles.counter}>{counter}</span>
//       )}
//     </>
//   )

//   const className = classNames(styles.tabbar__button, {
//     [styles.addingCart]: isAddingCart,
//   })

//   if (href) {
//     // Если href есть, рендерим Link
//     return (
//       <Link to={href} className={className} {...props}>
//         {content}
//       </Link>
//     )
//   }
//   else {
//     // Если нет href, то рендерим кнопку
//     return (
//       <button
//         type="button"
//         className={classNames('reset-button', className)}
//         {...props}
//       >
//         {content}
//       </button>
//     )
//   }
// }

type TabBarProps = {
  showCartButton?: boolean;
  withProductQuery?: boolean;
};

export const TabBar = ({
  showCartButton = true,
  withProductQuery = false,
}: TabBarProps) => {
  const { t: tp } = useTranslation('product')
  const { slug } = useParams()
  const { shopId } = useAddressStore()

  const { openCartModal } = useCartModal()
  const { cartInfoData, getTotalQuantity } = useCartStore()

  const { data: { product } = {} } = useProductQuery({
    variables: {
      shopId: shopId,
      slug,
      previewStyle2: '800xauto',
    },
    skip: !withProductQuery,
  })

  const modalTitle = useMemo(() => {
    const quantity = getTotalQuantity()
    return `${quantity} ${getNoun(
      quantity,
      tp('product.1'),
      tp('product.2'),
      tp('product.3'),
    )}`
  }, [ getTotalQuantity, tp ])

  return (
    <nav className={styles.tabbar}>
      <div className={styles.tabbar__bg}></div>

      <div className={styles.tabbar__row}>
        {withProductQuery && !!product && (
          <ControlCart
            isTablet={false}
            product={product as Product}
            isInTabBar={true}
          />
        )}

        {showCartButton && !withProductQuery && (
          <Button
            onClick={() => openCartModal({
              title: modalTitle
            })}
            className={styles.tabbar__cartButton}
          >
            <div className={styles.tabbar__cartButton_iconContainer}>
              <img
                src="/icons/shopping-cart-mobile.svg"
                alt=""
                loading="lazy"
                fetchPriority="low"
                className={styles.tabbar__cartButton_icon}
              />
              <span className={styles.tabbar__cartButton_counter}>{cartInfoData?.products?.length ?? 0}</span>
            </div>
            <span className={styles.tabbar__cartPrice}>{formatPrice(cartInfoData?.totals?.total as number ?? 0)}</span>
          </Button>
        )}
      </div>
    </nav>
  )
}
